import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { defaultFilters } from 'components/organisms/contactsFilters/defaultFilters';
import { useGetContactsQuery } from 'services/contactsV2';
import { useGetCustomFieldsQuery } from 'services/customFieldsV2';
import { companyDefaultFilters } from 'components/organisms/companyFilters/defaultFilters';
import { useContactsSearchParam } from './useContactsSearchParam';

export const useFetchContacts = ({ allList = true, defaultSort = {}, listKind = 'people' }) => {
  const { listId } = useParams();
  const [queryParams, setQueryParams] = useContactsSearchParam(
    {
      filters: listKind === 'companies' ? companyDefaultFilters : defaultFilters,
      listId: allList ? null : listId,
      ...(listId ? { contextualizedToSharedListId: listId } : undefined),
    },
    defaultSort,
  );
  const { data: customFields, isLoading: isLoadingCustomFields } = useGetCustomFieldsQuery({
    includeLists: !!listId,
    ...(listId ? { sharedListId: listId } : undefined),
  });

  const queryArgs = useMemo(
    () => ({
      ...queryParams,
      listKind,
      includeGlobalCustomFields: true,
      ...(allList && !listId ? { includeListsCustomFields: true } : undefined),
    }),
    [queryParams, listKind, allList, listId],
  );

  const {
    data = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetContactsQuery(queryArgs, {
    refetchOnMountOrArgChange: true,
  });

  return {
    listId: listId ? parseInt(listId, 10) : null,
    queryParams,
    setQueryParams,
    data,
    customFields: customFields || [],
    isLoading: isLoading || isLoadingCustomFields,
    isFetching,
    isLoadingAI: Boolean(data?.meta?.isLoadingAI),
    refetch,
  };
};
